// components/ui/LocationPrecisionToggle.js
import React from "react";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { MapPinIcon as MapPinSolid } from "@heroicons/react/24/solid";

export default function LocationPrecisionToggle({
  value,
  onChange,
  size = "md",
  className = "",
  disabled = false,
  units = "miles",
}) {
  const approxLabel = units === "kilometers" ? "~150m" : "~500ft";
  const sizeClasses = {
    sm: "px-3 py-1 text-xs gap-1",
    md: "px-4 py-1.5 text-sm gap-1",
    lg: "px-6 py-2 text-base gap-2",
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  const baseClasses = `flex items-center rounded-full border transition-colors ${sizeClasses[size]} disabled:opacity-50 disabled:cursor-not-allowed`;

  const getButtonClasses = (precision) => {
    const isSelected = value === precision;

    if (precision === "exact") {
      return isSelected
        ? "bg-primary border-border-primary-500 text-text-inverse shadow-sm"
        : "border-border-strong text-text-muted hover:bg-surface";
    } else {
      return isSelected
        ? "bg-surface-sunken border-border-strong text-text-secondary shadow-sm"
        : "border-border-strong text-text-muted hover:bg-surface";
    }
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <button
        onClick={() => onChange("exact")}
        disabled={disabled}
        className={`${baseClasses} ${getButtonClasses("exact")}`}
      >
        <MapPinSolid className={iconSizes[size]} />
        Exact
      </button>
      <button
        onClick={() => onChange("approximate")}
        disabled={disabled}
        className={`${baseClasses} ${getButtonClasses("approximate")}`}
      >
        <MapPinIcon className={iconSizes[size]} />
        {approxLabel}
      </button>
    </div>
  );
}
